import { Component, computed, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { CONTEXT_HELP_ACTION, menuFor } from "./modules/fx-infinity/pages-menu";
import { NbMenuModule, NbMenuService, NbThemeModule } from "@nebular/theme";
import { ThemeModule } from "./@theme/theme.module";
import { RouterModule } from "@angular/router";
import { filter } from "rxjs/operators";
import { QaBannerComponent } from "./shared/components/qa-banner/qa-banner.component";
import { AuthService } from "./modules/vnext/auth/auth-service.service";
import { HelpPanelComponent } from "./modules/help/help-panel/help-panel.component";
import { HelpPanelService } from "./modules/help/help-panel.service";

@Component({
    selector: "ngx-app",
    template: `
    <ngx-qa-banner></ngx-qa-banner>
    <ngx-one-column-layout>
      <nb-menu [items]="menu()"></nb-menu>
      <router-outlet></router-outlet>
    </ngx-one-column-layout>
    <ngx-help-panel></ngx-help-panel>
  `,
    standalone: true,
    imports: [NbThemeModule, ThemeModule, NbMenuModule , RouterModule, QaBannerComponent, HelpPanelComponent],
})
/**
 * Root component of the A2Pay backoffice POS. Hosts the one-column Nebular
 * layout with the side navigation menu and the router outlet for feature screens,
 * and the help panel that opens over them (work item 830).
 */
export class AppComponent {
  private readonly auth = inject(AuthService);

  /**
   * Side navigation menu entries (Loans, Wallet, Admin, Help sections). Entries that need a
   * permission appear once the sign-in bootstrap has loaded the user's permissions.
   */
  readonly menu = computed(() => menuFor(this.auth.loansPermissions()));

  constructor() {
    const help = inject(HelpPanelService);
    inject(NbMenuService).onItemClick()
      .pipe(filter((event) => event.item.data?.action === CONTEXT_HELP_ACTION), takeUntilDestroyed())
      .subscribe(() => help.openForCurrentScreen());
  }
}
